
    <div class="box">
        <img src="./img/humaans.png" alt="humaans" />
        <a href="https://www.pablostanley.com/">
            <span> Images come from Pablo Stanley Humans Collections </span>
        </a>
    </div>

<style>
    .box {
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
